'use client'
import React from 'react'
import { Column, TableHeaderVariants } from '../../../../types'
import { TableHeaderCell } from './TableHeaderCell'
import { useTableContext } from '../../../../providers'

export interface TableHeaderProps {}

export const TableHeader = ({}: TableHeaderProps): JSX.Element => {
    const { columns, isScrollable, isInline, headerVariant } = useTableContext()

    return (
        <thead className={`text-left z-10 ${isScrollable ? 'sticky top-0' : ''}`}>
            <tr
                className={
                    isInline && headerVariant !== TableHeaderVariants.QUIET ? 'border-x border-border-default' : ''
                }
            >
                {columns.map((column: Column, index: number) => (
                    <TableHeaderCell key={index} column={column}>
                        {column.title}
                    </TableHeaderCell>
                ))}
            </tr>
        </thead>
    )
}
